import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Top from "./Top";
import Right from "./Right";
import { getUserFromToken } from "../../function";
import { server } from "../../server";
import { fetchUserProfile } from "../../redux/profileSlice";
import { useDispatch, useSelector } from "react-redux";

function Dashboard() {
  const dispatch = useDispatch();
  const token = localStorage.getItem("authToken");
  const user = getUserFromToken();
  const [showBasicModal, setShowBasicModal] = useState(false);
  const { user: profileData, totalUploaedImages } = useSelector(
    (state) => state.profile,
  );

  const [activePlan, setActivePlan] = useState([]);
  const [membershipDetails, setMembershipDetails] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (user?._id) {
      dispatch(fetchUserProfile({ userId: user._id, token }));
    }
  }, [user?._id, token, dispatch]);

  const fetchMembershipById = async (id) => {
    const res = await fetch(`${server}/Membership/GetMembershipById?id=${id}`, {
      headers: { Authorization: localStorage.getItem("authToken") },
    });
    return res.json();
  };

  useEffect(() => {
    if (!user?._id) return;

    const fetchMembershipData = async () => {
      try {
        const res = await fetch(
          `${server}/GetMembershipPlanAndHistory?userObjectId=${user._id}`,
          {
            headers: { Authorization: localStorage.getItem("authToken") },
          },
        );

        const data = await res.json();

        const plansObject = data?.plans || {};
        const plansArray = Object.entries(plansObject).map(([type, plan]) => ({
          type,
          ...plan,
        }));

        setActivePlan(plansArray);
        const details = await Promise.all(
          plansArray.map((plan) =>
            fetchMembershipById(plan.planId).then((res) => ({
              planId: plan.planId,
              data: res,
            })),
          ),
        );

        const detailsMap = {};
        details.forEach((d) => {
          detailsMap[d.planId] = d.data;
        });

        setMembershipDetails(detailsMap);
      } catch (err) {
        console.error("Membership fetch error:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchMembershipData();
  }, [user?._id]);

  const regularPlan = activePlan.find((p) => p.type === "regular");
  const basicPlans = activePlan.filter((p) => p.type === "basic");

  const totalPhotoLimit =
    (regularPlan
      ? Number(membershipDetails[regularPlan.planId]?.photoLimit) || 0
      : 0) +
    basicPlans.reduce(
      (sum, plan) =>
        sum + (Number(membershipDetails[plan.planId]?.photoLimit) || 0),
      0,
    );

  useEffect(() => {
    if (!basicPlans.length) return;

    const hasRemainingBasicEvent = basicPlans.some(
      (p) => p.remainingEvents >= 1,
    );

    const modalShown = sessionStorage.getItem("basicEventModalShown");

    if (hasRemainingBasicEvent && !modalShown) {
      setShowBasicModal(true);
      sessionStorage.setItem("basicEventModalShown", "true");
    }
  }, [basicPlans]);

  return (
    <>
      <main>
        <Top />

        <div className="container">
          <div className="row g-3">
            <div className="col-lg-9 col-12 py-2">
              <section className="position-relative z-1">
                <div className="pb-2 d-flex gap-0 align-items-md-center justify-content-between">
                  <div>
                    <h1 className="mb-0 h4 text-light lh-1 fw-medium">
                      Dashboard
                    </h1>
                    <nav aria-label="breadcrumb" className="m-0">
                      <ol className="breadcrumb">
                        <li className="breadcrumb-item">
                          <span>Home</span>
                        </li>
                        <li className="breadcrumb-item active">Dashboard</li>
                      </ol>
                    </nav>
                  </div>

                  <div className="d-flex gap-1 align-items-center">
                    <Link
                      to="/all-events"
                      className="btn btn-light btn-sm border-0 px-4 rounded-3 fs-6 fw-medium d-lg-none d-block"
                    >
                      All Events
                    </Link>
                    <Link
                      to="/my-photos"
                      className="btn btn-light btn-sm border-0 px-4 rounded-3 fs-6 fw-medium d-lg-none d-block"
                    >
                      My Photos
                    </Link>
                  </div>
                </div>

                <div className="row align-items-center mt-2 g-0 gradient-section-1 rounded-4 overflow-hidden">
                  <div className="col-lg-7 col-12">
                    <div className="m-4 rounded-5">
                      <div className="d-flex align-items-center gap-4">
                        <Link className="action-button-lg rounded-circle">
                          <i className="bi bi-images fs-3 opacity-75 text-white"></i>
                        </Link>

                        <div>
                          <h4 className="mb-0 text-black fw-medium lh-1">
                            Welcome, {user?.name} 😊
                          </h4>
                          <p className="fs-6 m-0 text-dark">
                            Build Beautiful Gallery and Share Your Brand with AI
                          </p>
                          <p className="fs-6 m-0 text-dark lh-sm mt-2">
                            <i className="bi bi-check2-circle"></i>{" "}
                            {totalUploaedImages?.toLocaleString("en-IN")} /{" "}
                            {totalPhotoLimit > 0
                              ? totalPhotoLimit.toLocaleString("en-IN")
                              : "0"}{" "}
                            Photos Uploaded
                            <br />
                            <i className="bi bi-check2-circle"></i>{" "}
                            {profileData?.totalEventCreated || 0} Events Created
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-5 col-12 d-flex justify-content-center">
                    <img
                      src="/assets/images/files.png"
                      className="rounded-end-5 object-fit-cover"
                      height="140"
                    />
                  </div>
                </div>
              </section>

              <div className="row g-2 mt-1">
                <div className="col-lg-7 col-12">
                  <div className="bg-white p-5 h-100 rounded-4">
                    {loading ? (
                      <div className="spinner-border spinner-border-sm" />
                    ) : (
                      <>
                        <span className="text-primary d-block text-uppercase fw-semibold ls-lg fs-6">
                          Membership Details
                        </span>

                        {regularPlan &&
                          (() => {
                            const detail =
                              membershipDetails[regularPlan.planId];

                            return (
                              <div className="mb-2">
                                <h6 className="fw-semibold text-uppercase text-muted mt-1 mb-0 lh-1">
                                  Regular Plan
                                </h6>
                                <h3 className="fw-semibold mb-2 lh-sm">
                                  {detail?.plan} Plan
                                </h3>
                                <p className="fs-5 text-muted mb-2 lh-1">
                                  {detail?.planDescription}
                                </p>
                                <p className="fs-5 text-dark mb-1 lh-sm">
                                  Events Limit — {detail?.eventLimit}
                                  <br />
                                  Photos Limit —{" "}
                                  {detail?.photoLimit?.toLocaleString("en-IN")}
                                  <br />
                                  Remaining Events —{" "}
                                  {regularPlan.remainingEvents}
                                </p>
                                <p className="fs-5 text-success mb-0">
                                  Activated on{" "}
                                  {new Date(
                                    regularPlan.planActivatedAt,
                                  ).toLocaleDateString()}
                                </p>
                              </div>
                            );
                          })()}

                        {basicPlans.length > 0 && (
                          <>
                            <hr />
                            <h6 className="fw-semibold text-uppercase text-muted mt-4 mb-0 lh-1">
                              Basic / Event Plan
                            </h6>

                            {basicPlans.map((plan) => {
                              const detail = membershipDetails[plan.planId];

                              return (
                                <div key={plan.planId} className="mb-3">
                                  <h3 className="fw-semibold mb-2 lh-sm">
                                    {detail?.plan} Plan
                                  </h3>
                                  <p className="fs-5 text-dark lh-sm mb-1">
                                    Events Limit — {detail?.eventLimit}
                                    <br />
                                    Photos Limit —{" "}
                                    {detail?.photoLimit?.toLocaleString(
                                      "en-IN",
                                    )}
                                  </p>
                                  <p className="fs-5 text-muted mb-0">
                                    Activated on{" "}
                                    {new Date(
                                      plan.planActivatedAt,
                                    ).toLocaleDateString()}
                                  </p>
                                </div>
                              );
                            })}
                          </>
                        )}
                      </>
                    )}
                  </div>
                </div>

                <div className="col-lg-5 col-12">
                  <div className="card bg-dark-primary rounded-4 border-0 h-100 text-center">
                    <div className="card-body py-4 d-flex flex-column justify-content-center align-items-center">
                      <img src="/assets/images/giftbox.png" width="90" />
                      <h5 className="text-white mt-4 fs-6 mb-0 lh-1">
                        Unlimited Access
                      </h5>
                      <p className="text-white-50 fs-6">
                        Upgrade your plan from a Free trial to premium.
                      </p>
                      <Link
                        to="/pricing"
                        className="btn btn-white btn-sm px-4 rounded-pill"
                      >
                        Upgrade Now
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-3 col-12">
              <Right />
            </div>
          </div>
        </div>

        {showBasicModal && (
          <div
            className="modal fade show"
            style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
            tabIndex="-1"
          >
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content rounded-4 overflow-hidden">
                {/* Header */}
                <div className="modal-header border-0">
                  <button
                    type="button"
                    className="btn-close mt-1 cursor-pointer text-dark"
                    onClick={() => setShowBasicModal(false)}
                  />
                </div>

                <div className="modal-body text-center px-4 pt-4 pb-2 mt-n6">
                  <h4 className="fw-medium mb-2 fst-italic">
                    You still have Events Left{" "}
                    <span className="display-5 ms-1">🎉</span>
                  </h4>

                  <p className="fs-5 mb-1">
                    You have{" "}
                    <span className="fw-bold text-primary">
                      {basicPlans[0]?.remainingEvents}
                    </span>{" "}
                    remaining event in your{" "}
                    <i className="text-dark">Basic / Event Plan</i>.
                  </p>

                  <p className="text-muted fs-5 mb-0 lh-sm">
                    Don’t let it go to waste. Create an event and start
                    uploading photos, sharing galleries, and engaging your
                    audience.
                  </p>
                </div>

                {/* Footer */}
                <div className="modal-footer border-0 justify-content-center pb-5">
                  <Link
                    to="/create-event"
                    className="btn btn-primary px-4 rounded-pill d-flex align-items-center gap-2 px-6 fw-light"
                    onClick={() => setShowBasicModal(false)}
                  >
                    <i className="bi bi-plus-circle"></i>
                    Create Event
                  </Link>

                  <button
                    className="btn btn-outline-secondary px-4 rounded-pill px-6 fw-light"
                    onClick={() => setShowBasicModal(false)}
                  >
                    Maybe Later
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </main>
    </>
  );
}

export default Dashboard;
